import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { AgingMethod } from 'src/app/products/interfaces/aging-method';
import { BrewingProcess } from 'src/app/products/interfaces/brewing-process';
import { FruitSpiritFlavor } from 'src/app/products/interfaces/fruit-spirit-flavor';
import { FruitSpiritOtherFlavor } from 'src/app/products/interfaces/fruit-spirit-other-flavor';
import { FruitSpiritType } from 'src/app/products/interfaces/fruit-spirit-type';
import { FruitSpiritVegetableFlavor } from 'src/app/products/interfaces/fruit-spirit-vegetable-flavor';
import { SubformBaseComponent } from 'src/app/shared/components/subform-base/subform-base.component';

import { FruitSpiritProperties } from '@app/api/marketplace/models';

@Component({
  selector: 'app-fruit-spirit-properties-subform',
  templateUrl: './fruit-spirit-properties-subform.component.html',
  styleUrls: ['./fruit-spirit-properties-subform.component.scss'],
})
export class FruitSpiritPropertiesSubformComponent extends SubformBaseComponent {
  DICT_PATH = 'PRODUCTS.FRUIT_SPIRIT_PROPERTIES';

  types = FruitSpiritType;
  brewingProcesses = BrewingProcess;
  flavors = FruitSpiritFlavor;
  otherFlavors = FruitSpiritOtherFlavor;
  vegetableFlavors = FruitSpiritVegetableFlavor;
  agingMethods = AgingMethod;

  static buildForm(
    fb: FormBuilder,
    data: FruitSpiritProperties | undefined,
    isSecondaryProductSheet: boolean
  ) {
    return fb.group({
      type: [data?.type, Validators.required],
      flavor: [data?.flavor, Validators.required],
      // otherFlavor:
      ...(data?.flavor === FruitSpiritFlavor.Other && {
        otherFlavor: [data?.otherFlavor, Validators.required],
      }),
      // vegetableFlavor:
      ...(data?.flavor === FruitSpiritFlavor.Vegetable && {
        vegetableFlavor: [data?.vegetableFlavor, Validators.required],
      }),
      ...(!isSecondaryProductSheet && {
        brewingProcess: [data?.brewingProcess, Validators.required],
        agingMethod: [data?.agingMethod],
      }),
    });
  }

  onFlavorSelected(selected?: FruitSpiritFlavor) {
    // otherFlavor
    if (selected === FruitSpiritFlavor.Other) {
      this.group.addControl(
        'otherFlavor',
        this.fb.control(null, Validators.required)
      );
    } else {
      this.group.removeControl('otherFlavor');
    }

    // vegetableFlavor
    if (selected === FruitSpiritFlavor.Vegetable) {
      this.group.addControl(
        'vegetableFlavor',
        this.fb.control(null, Validators.required)
      );
    } else {
      this.group.removeControl('vegetableFlavor');
    }
  }
}
